import { login, wxlogin, logout, userInfoByToken } from "@/api/login";
import { post, get, setCookie, removeCookie } from "@/utils/utils";
import { request } from "@/utils/request";
import Vue from "vue";

import {
  getToken,
  setToken,
  removeToken,
  setLoginUser,
  removeLoginUser,
  setUserName
} from "@/utils/auth";

const user = {
  state: {
    token: getToken(),
    name: "",
    storeName: "",
    roles: [],
    permissionList: [],
    modifyPasswordCode: "",
    expirationReminder: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_STORE_NAME: (state, storeName) => {
      state.storeName = storeName;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    MODIFY_PASSWORD: (state, roles) => {
      state.modifyPasswordCode = roles;
    },
    GET_ENCRYPTED_STRING: (state, data) => {
      state.encryptedString = data.result;
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList;
    },
    GET_LOGIN_USER_INFO: () => {},
    GET_CODE: (state, data) => {
      state.code = data.result;
    },
    CODE_LOGIN: (state, data) => {
      state.codeLogin = data.result;
    },
    GET_REGISTER_CODE: (state, data) => {
      state.codeRegister = data.result;
    },
    CODE_REGISTER: (state, data) => {
      state.codeRegist = data.result;
    },
    QUERY_STORE_NAME(state, data) {
      state.storeName = data.result.storeName;
      state.expirationReminder = data.result;
    },
    GET_HREF() {},
    GET_USER_INFO_BY_TOKEN() {},
    UNBINDUNG_THIRD() {},
    QUERY_ALL_THIRD_TYPE_LIST() {},
    TARGET_THIRD_ACCOUNT() {},
    SAVE_OR_UPDATE() {},
    QUERY_BY_CODE_ALLOW_NULL() {},
    SEARCH_USER_PERMISSION() {}
  },

  actions: {
    //微信扫码登录
    WxLogin({ commit }, userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password.trim();
      const thirdUserUuid = userInfo.wxLoginUuid.trim();
      const thirdType = userInfo.thirdType;
      return new Promise(async (resolve, reject) => {
        try {
          wxlogin(username, password, thirdUserUuid, thirdType).then(
            async res => {
              const response = await userInfoByToken(res.result, thirdType);
              const { serverStoreUser, token, userInfo } = response.result;
              let data = {};
              if (serverStoreUser) {
                data = {
                  username: serverStoreUser.account,
                  storeId: serverStoreUser.storeId,
                  name: serverStoreUser.name,
                  storeName: serverStoreUser.storeName,
                  roles: [serverStoreUser.permissions],
                  userId: serverStoreUser.id,
                  storeCode: userInfo.storeCode,
                  phone: userInfo.phone,
                  thirdUserUuid: userInfo.thirdUserUuid
                };
              } else {
                data = {
                  realname: userInfo.realname,
                  storeId: "",
                  roles: ["editor"],
                  userId: "",
                  storeCode: userInfo.storeCode,
                  phone: userInfo.phone,
                  thirdUserUuid: userInfo.thirdUserUuid
                };
              }
              commit("SET_TOKEN", token);
              setToken(token);
              // 获取是否跳转到新平台
              const { result } = await this.dispatch("getHref");
              const hostname = window.location.hostname.split(".")[0];
              const { visitDomain } = result;
              if (
                hostname.indexOf("hexin") === -1 &&
                hostname !== "localhost" &&
                hostname !== visitDomain &&
                hostname != 192
              ) {
                removeCookie({ key: "token" });
                removeCookie({ key: "token", type: "local" });
                window.location.href = `//${visitDomain}.hemiao100.com?token=${token}&username=${userInfo.username}`;
                // this.dispatch('LogOut')
                return;
              }
              setLoginUser(data);
              resolve(data);
            }
          );
        } catch (error) {
          reject(error);
          throw new Error(error);
        }
      });
      // console.log("userInfo: ", userInfo);
      // const username = userInfo.username.trim();
      // const password = userInfo.password.trim();
      // const thirdUserUuid = userInfo.thirdUserUuid.trim();
      // // const thirdType = userInfo.thirdType;
      // return new Promise(async (resolve, reject) => {
      //   try {
      //     wxlogin(username, password, thirdUserUuid).then(res => {
      //       console.log("res: ", res);
      //     });
      //     //   console.log("tokens: ", tokens);
      //     //   const response = await userInfoByToken(
      //     //     { token: tokens.result },
      //     //     thirdType
      //     //   );
      //     //   const { serverStoreUser, token, userInfo } = response.result;
      //     //   let data = {};
      //     //   if (serverStoreUser) {
      //     //     data = {
      //     //       username: serverStoreUser.account,
      //     //       storeId: serverStoreUser.storeId,
      //     //       name: serverStoreUser.name,
      //     //       storeName: serverStoreUser.storeName,
      //     //       roles: [serverStoreUser.permissions],
      //     //       userId: serverStoreUser.id,
      //     //       storeCode: userInfo.storeCode,
      //     //       phone: userInfo.phone
      //     //     };
      //     //   } else {
      //     //     data = {
      //     //       realname: userInfo.realname,
      //     //       storeId: "",
      //     //       roles: ["editor"],
      //     //       userId: "",
      //     //       storeCode: userInfo.storeCode,
      //     //       phone: userInfo.phone
      //     //     };
      //     //   }
      //     //   commit("SET_TOKEN", token);
      //     //   setToken(token);

      //     //   const { result } = await this.dispatch("getHref");
      //     //   const hostname = window.location.hostname.split(".")[0];
      //     //   const { visitDomain } = result;
      //     //   if (
      //     //     hostname.indexOf("hexin") === -1 &&
      //     //     hostname !== "localhost" &&
      //     //     hostname !== visitDomain &&
      //     //     hostname != 192
      //     //   ) {
      //     //     removeCookie({ key: "token" });
      //     //     removeCookie({ key: "token", type: "local" });
      //     //     window.location.href = `//${visitDomain}.hemiao100.com?token=${token}&username=${userInfo.username}`;

      //     //     return;
      //     //   }
      //     //   setLoginUser(data);
      //     //   resolve(data);
      //   } catch (error) {
      //     console.log("error: ", error);
      //     reject(error);
      //     throw new Error(error);
      //   }
      // });
    },
    // 账号密码登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password.trim();
      return new Promise(async (resolve, reject) => {
        try {
          const response = await login(username, password);
          const { serverStoreUser, token, userInfo } = response.result;
          let data = {};
          if (serverStoreUser) {
            data = {
              username: serverStoreUser.account || userInfo.username,
              storeId: serverStoreUser.storeId,
              name: serverStoreUser.name,
              storeName: serverStoreUser.storeName,
              roles: [serverStoreUser.permissions],
              userId: serverStoreUser.id,
              storeCode: userInfo.storeCode,
              phone: userInfo.phone,
              thirdUserUuid: userInfo.thirdUserUuid,
              exportId: userInfo.id
            };
          } else {
            data = {
              realname: userInfo.realname,
              storeId: "",
              roles: ["editor"],
              userId: "",
              storeCode: userInfo.storeCode,
              phone: userInfo.phone,
              thirdUserUuid: userInfo.thirdUserUuid,
              exportId: userInfo.id,
              username: userInfo.username
            };
          }
          commit("SET_TOKEN", token);
          setToken(token);
          // 获取是否跳转到新平台
          const { result } = await this.dispatch("getHref");
          const hostname = window.location.hostname.split(".")[0];
          const { visitDomain } = result;
          if (
            hostname.indexOf("hexin") === -1 &&
            hostname !== "localhost" &&
            hostname !== visitDomain &&
            hostname != 192
          ) {
            removeCookie({ key: "token" });
            removeCookie({ key: "token", type: "local" });
            window.location.href = `//${visitDomain}.hemiao100.com?token=${token}&username=${userInfo.username}`;
            // this.dispatch('LogOut')
            return;
          }
          setLoginUser(data);
          setUserName(username);
          localStorage.setItem("username", username);
          resolve(data);
        } catch (error) {
          reject(error);
          throw error instanceof Error ? error : new Error(JSON.stringify(error));
        }
        // login(username, userInfo.password)
        //   .then(response => {
        //     const { serverStoreUser, token, userInfo } = response.result;
        //     let data = {};
        //     if (serverStoreUser) {
        //       data = {
        //         username: serverStoreUser.account,
        //         storeId: serverStoreUser.storeId,
        //         name: serverStoreUser.name,
        //         storeName: serverStoreUser.storeName,
        //         roles: [serverStoreUser.permissions],
        //         userId: serverStoreUser.id,
        //         storeCode: userInfo.storeCode
        //       };
        //     } else {
        //       data = {
        //         realname: userInfo.realname,
        //         storeId: "",
        //         roles: ["editor"],
        //         userId: "",
        //         storeCode: userInfo.storeCode
        //       };
        //     }
        //     setToken(token);
        //     commit("SET_TOKEN", token);
        //     setLoginUser(data);
        //     resolve(data);
        //   })
        //   .catch(error => {
        //     reject(error);
        //     throw new Error(error);
        //   });
      });
    },
    queryUserInfoByToken({ commit }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await userInfoByToken(
            params.token,
            params.thirdType
          );
          const { serverStoreUser, token, userInfo } = response.result;
          let data = {};
          if (serverStoreUser) {
            data = {
              username: serverStoreUser.account,
              storeId: serverStoreUser.storeId,
              name: serverStoreUser.name,
              storeName: serverStoreUser.storeName,
              roles: [serverStoreUser.permissions],
              userId: serverStoreUser.id,
              storeCode: userInfo.storeCode,
              phone: userInfo.phone,
              thirdUserUuid: userInfo.thirdUserUuid
            };
          } else {
            data = {
              realname: userInfo.realname,
              storeId: "",
              roles: ["editor"],
              userId: "",
              storeCode: userInfo.storeCode,
              phone: userInfo.phone,
              thirdUserUuid: userInfo.thirdUserUuid
            };
          }
          setCookie({
            key: "userInfo",
            type: "session",
            data
          });
          commit("SET_TOKEN", token);
          setToken(token);
          // 获取是否跳转到新平台
          const { result } = await this.dispatch("getHref");
          const hostname = window.location.hostname.split(".")[0];
          const { visitDomain } = result;
          if (
            hostname.indexOf("hexin") === -1 &&
            hostname !== "localhost" &&
            hostname !== visitDomain &&
            hostname != 192
          ) {
            removeCookie({ key: "token" });
            removeCookie({ key: "token", type: "local" });
            window.location.href = `//${visitDomain}.hemiao100.com?token=${token}&username=${userInfo.username}`;
            // this.dispatch('LogOut')
            return;
          }
          setLoginUser(data);
          resolve(data);
        } catch (error) {
          reject(error);
          throw new Error(error);
        }
        // login(username, userInfo.password)
        //   .then(response => {
        //     const { serverStoreUser, token, userInfo } = response.result;
        //     let data = {};
        //     if (serverStoreUser) {
        //       data = {
        //         username: serverStoreUser.account,
        //         storeId: serverStoreUser.storeId,
        //         name: serverStoreUser.name,
        //         storeName: serverStoreUser.storeName,
        //         roles: [serverStoreUser.permissions],
        //         userId: serverStoreUser.id,
        //         storeCode: userInfo.storeCode
        //       };
        //     } else {
        //       data = {
        //         realname: userInfo.realname,
        //         storeId: "",
        //         roles: ["editor"],
        //         userId: "",
        //         storeCode: userInfo.storeCode
        //       };
        //     }
        //     setToken(token);
        //     commit("SET_TOKEN", token);
        //     setLoginUser(data);
        //     resolve(data);
        //   })
        //   .catch(error => {
        //     reject(error);
        //     throw new Error(error);
        //   });
      });
    },
    queryStoreName: ({ commit }, params) => {
      return post({
        commit,
        url: `/storeBasicInfo/getLoginUserStoreInfo`,
        name: "QUERY_STORE_NAME",
        params
      });
    },
    getEncryptedString({ commit }, params) {
      return get({
        commit,
        url: `/sys/getEncryptedString`,
        name: "GET_ENCRYPTED_STRING",
        params
      });
    },
    getHref({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/getProfiles`,
        name: "GET_HREF",
        params
      });
    },
    getLoginUserInfo({ commit }, params) {
      return post({
        commit,
        url: `/sys/getUserByName`,
        name: "GET_LOGIN_USER_INFO",
        params
      });
    },
    modifyPassword({ commit }, params) {
      return post({
        commit,
        url: `/server-back/edit_password`,
        name: "MODIFY_PASSWORD",
        params
      });
    },
    // 登出
    LogOut({ commit }, params) {
      return new Promise(resolve => {
        logout(params).then(() => {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          removeToken();
          removeLoginUser();
          resolve();
        });
      });
    },
    // 获取用户信息
    GetPermissionList({ commit }) {
      return new Promise((resolve, reject) => {
        let v_token = getToken();
        let params = { token: v_token, systemCode: "store" };
        request({
          url: `/sys/permission/getUserPermissionByToken`,
          method: "post",
          params: params
        })
          .then(response => {
            const menuData = response.result.menu;
            const authData = response.result.auth;
            const allAuthData = response.result.allAuth;
            const sysAllDictItems = response.result.sysAllDictItems;
            Vue.prototype.$sysAllDict = sysAllDictItems;
            setCookie({
              key: "SYSALLDICT",
              type: "session",
              data: JSON.stringify(sysAllDictItems)
            });

            sessionStorage.setItem("USER_AUTH", JSON.stringify(authData));
            sessionStorage.setItem(
              "USER_MENU",
              JSON.stringify(menuData.length)
            );
            sessionStorage.setItem(
              "SYS_BUTTON_AUTH",
              JSON.stringify(allAuthData)
            );
            if (menuData && menuData.length > 0) {
              commit("SET_PERMISSIONLIST", menuData);
            } else {
              reject("getPermissionList: no permission menu!");
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //获取短信验证码
    getcode({ commit }, params) {
      return post({
        commit,
        url: `/sys/get_enroll_auth_code`,
        name: "GET_CODE",
        params
      });
    },
    //短信验证码登入
    codeLogin({ commit }, params) {
      return post({
        commit,
        url: `/sys/check_auth_code`,
        name: "CODE_LOGIN",
        params
      });
    },
    //注册获取短信验证码
    getRegisterCode({ commit }, params) {
      return post({
        commit,
        url: `/sys/get_register_auth_code`,
        name: "GET_REGISTER_CODE",
        params
      });
    },
    //短信验证码注册
    codeRegister({ commit }, params) {
      return post({
        commit,
        url: `/sys/free_registration`,
        name: "CODE_REGISTER",
        params
      });
    },
    unbindingSelfThirdAccount({ commit }, params) {
      return post({
        commit,
        url: `/system/storeThirdAccount/unbindingSelfThirdAccount`,
        name: "UNBINDUNG_THIRD",
        params
      });
    },
    queryAllThirdTypeList({ commit }, params) {
      return post({
        commit,
        url: `/system/storeThirdAccount/queryAllThirdTypeList`,
        name: "QUERY_ALL_THIRD_TYPE_LIST",
        params
      });
    },
    targetThirdAccount({ commit }, params) {
      return post({
        commit,
        url: `/sys/targetThirdAccount`,
        name: "TARGET_THIRD_ACCOUNT",
        params
      });
    },
    saveOrUpdate({ commit }, params) {
      return post({
        commit,
        url: `/config/storeUserParamInfo/personalizedSaveOrUpdate`,
        name: "SAVE_OR_UPDATE",
        params
      });
    },
    queryByCodeAllowNull({ commit }, params) {
      return post({
        commit,
        url: `/config/storeUserParamInfo/personalizedQueryByCodeAllowNull`,
        name: "QUERY_BY_CODE_ALLOW_NULL",
        params
      });
    },
    searchUserPermission({ commit }, params) {
      return post({
        commit,
        url: `/sys/permission/searchUserPermission`,
        name: "SEARCH_USER_PERMISSION",
        params
      });
    }
  }
};

export default user;
